var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"homepage-settings-content"},[_c('section',{staticClass:"flex-grow"},[_c('main',{attrs:{"id":"scroll-container"}},[_c('v-container',{staticClass:"pt-16"},[_c('keep-alive',[_c(_vm.currentComponent,{tag:"component"})],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }